import { render } from "./EditIssue.vue?vue&type=template&id=2a726150"
import script from "./EditIssue.vue?vue&type=script&lang=js"
export * from "./EditIssue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__